import React from "react"
import PropTypes from "prop-types"
import dayjs from "dayjs"
import DatePicker from "react-datepicker"

const CustomDatePicker = ({ value, onClick, onClear }) => (
  <button className='cs-button white' style={{ width: "300px", paddingLeft: "40px" }} onClick={onClick}>
    {value ? value : "None Selected"}
    {value ? <span
      className='material-icons'
      onClick={e => {
        e.stopPropagation()
        onClear()
      }}
      style={{ position: "absolute", right: "10px", top: "10px", fontSize: "20px", color: "#666" }}>close</span>
    : null}
  </button>
)

CustomDatePicker.propTypes = {
  value: PropTypes.string,
  onClick: PropTypes.func
}

const getDate = value => {
  if (value && dayjs(value).isValid()) {
    return dayjs
      .utc(value)
      .local()
      .toDate()
  }
  return null
}

const AvailabilityAndExpiryDates = ({ model, updateModel }) => {
  return (
    <div className='p2 border-bottom border-gray-5'>
      <div className='flex items-center justify-between'>
        <div className='mr3'>
          <label className='cs-label' htmlFor='expiry'>
            Available At (local time):
          </label>
          <DatePicker
            selected={getDate(model.available_at)}
            onChange={e => updateModel("available_at", e.toISOString())}
            minDate={new Date()}
            showTimeSelect
            timeFormat='HH:mm'
            timeIntervals={1}
            timeCaption='time'
            dateFormat='MMMM d, yyyy h:mm aa'
            shouldCloseOnSelect={false} 
            showTimeInput 
            customInput={<CustomDatePicker onClear={() => updateModel("available_at", null)}/>}/>
          <p className='italic mt1'>
            {model.available_at ? (
              <span>
                UTC: {dayjs.utc(model.available_at).format("MMM D, YYYY [at] h:mma")}
              </span>
            ) : (
              <span>Available immediately.</span>
            )}
          </p>
        </div>
        <div>
          <label className='cs-label' htmlFor='expiry'>
            Expires At (local time):
          </label>
          <DatePicker
            selected={getDate(model.expiry)}
            onChange={e => updateModel("expiry", e.toISOString())}
            minDate={new Date()}
            showTimeSelect
            timeFormat='HH:mm'
            timeIntervals={1}
            timeCaption='time'
            dateFormat='MMMM d, yyyy h:mm aa'
            shouldCloseOnSelect={false} 
            showTimeInput 
            customInput={<CustomDatePicker onClear={() => updateModel("expiry", null)}/>}/>
          <p className='italic mt1'>
            {model.expiry ? (
              <span>
                UTC: {dayjs.utc(model.expiry).format("MMMM D, YYYY [at] h:mma")}
              </span>
            ) : (
              <span>Never expires.</span>
            )}
          </p>
        </div>
      </div>
      {dayjs(model.expiry).isBefore(dayjs(model.available_at)) && model.expiry && model.available_at ? (
        <div className='red mt2'>Expiry date must be after availablility date</div>
      ) : null}
    </div>
  )
}


export default AvailabilityAndExpiryDates
